<form class="theme-primary" [ngClass]="styles.wrapper" name="dialogForm" (submit)="submit()">
	<div class="modal-header theme-accent-bg theme-accent-border" [ngClass]="styles.header">
		<span class="theme-accent-txt">
			{{ (isApproved ? 'VideoApproved' : 'VideoRejected') | translate }}
		</span>
	</div>
	<div class="modal-body">
		<textarea type="text" name="approvalReason" [attr.aria-label]="'Reason' | translate " autofocus rows="10" [placeholder]="'AddOptionalMessage' | translate " [(ngModel)]="reason" vbUiTextArea [ngClass]="styles.reason">
		</textarea>
	</div>
	<div class="modal-footer new-panel-footer">
		<div class="pull-right">
			<button type="button" vbUiBtnSecondaryNgx [disabled]="isProcessing" (click)="cancel()" class="margin-right-5">
				{{ 'Cancel' | translate }}
			</button>
			<button type="submit" vbUiBtnPrimaryNgx>
				<span [hidden]="isProcessing">
					{{ 'Ok' | translate }}
				</span>
				<span [hidden]="!isProcessing">
					<vb-loading-spinner [size]="'small'"></vb-loading-spinner>
					{{ 'Processing' | translate }}
				</span>
			</button>
		</div>
	</div>
</form>
